import React, { useState, useEffect } from 'react';
import { actionsType } from 'config/constants';
import Modal from "components/Modal";
import Items from './Items';
import PubSub from 'services/PubSub';
import style from './style.scss';

let actions = [];

const ModalFoodCertificates = () => {
    const [items, setItems] = useState(null)
    useEffect(() => {
        actions.push(PubSub.register(actionsType.MODAL.FOOD_CERTIFICATES_OPEN, _open));

        return function cleanup() {
            actions = actions.map(token => PubSub.unregister(token));
            actions = [];
        };
    }, []);

    const _open = (payload) => {
        const product = payload.value.product;
        setItems(payload ? (product['Condiciones Alimentarias'] || product['Elaboración'] || product['Condiciones Alimentarias'].push(product['Elaboración'])) : null);
    }

    const closeModal = () => {
        setTimeout(()=> PubSub.dispatch(actionsType.MODAL.FOOD_CERTIFICATES_CLOSE),0);
    }

    return (
        <Modal customClass='modal-food-certificates' actionOpen={actionsType.MODAL.FOOD_CERTIFICATES_OPEN} actionClose={actionsType.MODAL.FOOD_CERTIFICATES_CLOSE}>
            <h3 className="new-modal-title">Características principales</h3>
            
            <div className={'new-modal-scroll'}>
                <Items items={items} closeModal={closeModal}/>
            </div>

            <div className={'modal-actions'}>
                <button className='primary-btn' onClick={() => closeModal()}>Volver</button>
            </div>
        </Modal>
    )
}

export default ModalFoodCertificates;